
import { Options, Vue } from "vue-class-component";
// components
import textbox from "@/components/textbox.vue";
// firebase
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  collection,
  doc,
  setDoc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db } from "@/firebase";
// tip tap
import { Editor } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";

@Options({
  components: {
    textbox,
  },
})
export default class Services extends Vue {
  // v-if values
  showPost = false;
  showEdit = false;

  // global data
  posts: any = [];
  currentPosts: any = [];
  categories: any = [];
  id: any = [];
  categoryId: any = [];

  // private data
  photoURL: any = String();

  // new post
  postContent: any = null;
  postTitle: any = String();
  shortDescription: any = String();
  postPhoto: any = String();
  photoName: any = String();
  postCategory: any = String();
  postURL: any = String();
  seo: any = {
    seoTitle: String(),
    seoDescription: "",
  };
  new_faqs: any = [];
  new_faq_question: any = String();
  new_faq_answer: any = String();

  // view post
  viewPost: any = {
    postTitle: String(),
    shortDescription: String(),
    postContent: String(),
    postPhoto: String(),
    postCategory: String(),
    faqs: [],
    seo: {
      seoTitle: String(),
      postURL: String(),
      seoDescription: "",
    },
  };

  // edit post
  editPost: any = {
    postKey: Number(),
    postTitle: String(),
    shortDescription: String(),
    postContent: null,
    postPhoto: String(),
    photoName: String(),
    postCategory: String(),
    seo: {
      seoTitle: String(),
      postURL: String(),
      seoDescription: "",
    },
  };
  edit_faq_question: any = String();
  edit_faq_answer: any = String();
  edit_faqs: any = [];

  created() {
    this.getPosts();
  }

  mounted() {
    this.getEditor();
  }

  beforeUnmount() {
    this.cleanEditor();
  }

  get postLink() {
    const newPostURL = this.postURL.replace(/\s+/g, "-").toLowerCase();
    return (this.postURL = newPostURL);
  }

  getPosts() {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        getDocs(collection(db, "services")).then((QuerySnapshot) => {
          QuerySnapshot.forEach((doc) => {
            this.currentPosts.push(doc.data());
            this.id.push(doc.id);
          });
        });
      }
    });
  }

  getEditor() {
    this.postContent = new Editor({
      content: "<p>Enter your new service content here.</p>",
      extensions: [StarterKit],
    });
    this.editPost.postContent = new Editor({
      content: "<p>Change your existing service content here.</p>",
      extensions: [StarterKit],
    });
  }

  cleanEditor() {
    this.postContent.destroy();
    this.editPost.postContent.destroy();
  }

  deletePost() {
    deleteDoc(doc(db, "services", this.id[this.editPost.postKey]));
    alert("Post has been deleted.");
  }

  newPhotoUpload(event: any) {
    this.postPhoto = event.target.files[0];
    this.photoName = event.target.files[0].name;
  }

  editPhotoUpload(event: any) {
    this.editPost.postPhoto = event.target.files[0];
    this.editPost.photoName = event.target.files[0].name;
  }

  addFAQ() {
    const faq: any = {
      title: this.new_faq_question,
      answer: this.new_faq_answer
    };

    this.new_faqs.push(faq);
  }

  deleteFAQ(index: number) {
    this.new_faqs.splice(index, 1);
  };

  addFAQtoExistingFAQ() {
    const faq: any = {
      title: this.edit_faq_question,
      answer: this.edit_faq_answer
    };

    this.edit_faqs.push(faq);
  };

  deleteEditFAQ(index: number) {
    this.edit_faqs.splice(index, 1);
  };

  updateFAQsInDatabase() {

    updateDoc(doc(db, "services", this.id[this.editPost.postKey]), { faqs: this.edit_faqs }).then(() => {
      alert("Frequently Asked Questions are Updated.");
    });

  };

  uploadPost() {
    getDoc(doc(db, "services", this.postURL)).then((DocSnap) => {
      if (DocSnap.exists()) {
        alert("URL already exists. Please specify a different URL.");
      } else {
        const storage = getStorage();
        uploadBytes(
          ref(storage, "serviceImages/" + this.postTitle + this.photoName),
          this.postPhoto
        )
          .then((snapshot) => {
            getDownloadURL(
              ref(storage, "serviceImages/" + this.postTitle + this.photoName)
            ).then((url) => {
              this.photoURL = url;
              if (this.photoURL != null) {
                const newPostData: any = {
                  postContent: this.postContent.getHTML(),
                  postTitle: this.postTitle,
                  shortDescription: this.shortDescription,
                  photoName: this.photoName,
                  postCategory: this.postCategory,
                  postPhoto: url,
                  postURL: this.postURL,
                  btntext: "Learn More",
                  seo: {
                    seoTitle: this.seo.seoTitle,
                    postURL: this.postURL,
                    seoDescription: this.seo.seoDescription,
                  },
                };
                setDoc(doc(db, "services", this.postURL), newPostData);
                alert(
                  "Post '" +
                  this.postTitle +
                  "' Successfully Added. Refresh the page to see the changes."
                );
              }
            });
          })
          .catch((error) => {
            console.log(error);
            alert(
              "Something happened on our end. Contact info@xdcmb.com for help."
            );
          });
        this.currentPosts = [];
        this.getPosts();
      }
    });
  }

  viewPostData(
    post: any,
    index: any
  ) {
    this.showPost = true;
    this.viewPost.postTitle = post.postTitle;
    this.viewPost.shortDescription = post.shortDescription;
    this.viewPost.postContent = post.postContent;
    this.viewPost.seo.seoTitle = post.seoTitle;
    this.viewPost.seo.postURL = post.postURL;
    this.viewPost.seo.seoDescription = post.seoDescription;
    this.viewPost.postCategory = post.postCategory;
    this.viewPost.postPhoto = post.postPhoto;
    if (post.faqs != '' && post.faqs != null && post.faqs != undefined) {
      this.edit_faqs = post.faqs;
      this.viewPost.faqs = post.faqs;
    }
    this.editPost.postKey = index;
    this.editPost.postContent = new Editor({
      content: post.postContent,
      extensions: [StarterKit],
    });
  }

  editPostUpload() {
    const newPostData: any = {
      postTitle: this.editPost.postTitle,
      shortDescription: this.editPost.shortDescription,
      postContent: this.editPost.postContent.getHTML(),
      postCategory: this.editPost.postCategory,
    };
    updateDoc(doc(db, "services", this.id[this.editPost.postKey]), newPostData);
    this.currentPosts = [];
    this.getPosts();
    alert(
      "Service '" +
      newPostData.newPostTitle +
      "' Successfully Updated. Refresh the page to see the changes."
    );
  }

  editPostSEO() {

    const newSeo = {
      seoTitle: this.viewPost.seo.seoTitle,
      seoDescription: this.viewPost.seo.seoDescription,
      postURL: this.viewPost.seo.postURL
    }

    if (this.editPost.seo.seoTitle != "") {

      newSeo.seoTitle = this.editPost.seo.seoTitle

      updateDoc(
        doc(db, "services", this.id[this.editPost.postKey]),
        { seo: newSeo }
      );
    }

    if (this.editPost.seo.seoDescription != "") {

      newSeo.seoDescription = this.editPost.seo.seoDescription

      updateDoc(
        doc(db, "services", this.id[this.editPost.postKey], "seo"),
        { seo: newSeo }
      );

    }

    if (this.editPost.seo.postURL != "") {

      newSeo.postURL = this.editPost.seo.postURL

      updateDoc(
        doc(db, "services", this.id[this.editPost.postKey], "seo"),
        { seo: newSeo }
      );

    }

    alert(
      "Project '" +
      this.viewPost.postTitle +
      "' Successfully Updated. Refresh the page to see the changes."
    );

    this.currentPosts = [];
    this.getPosts();

  }

  editImageUpload() {
    const storage = getStorage();
    uploadBytes(
      ref(
        storage,
        "serviceImages/" + this.viewPost.postTitle + this.editPost.photoName
      ),
      this.editPost.postPhoto
    ).then((snapshot) => {
      getDownloadURL(
        ref(
          storage,
          "serviceImages/" + this.viewPost.postTitle + this.editPost.photoName
        )
      ).then((url) => {
        updateDoc(doc(db, "services", this.id[this.editPost.postKey]), {
          postPhoto: url,
        });
        alert(
          "Post '" +
          this.viewPost.postTitle +
          "' Successfully Updated. Refresh the page to see the changes."
        );
        this.currentPosts = [];
        this.getPosts();
      });
    });
  }
}
